(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["r7-editorial-article"]) return;
  try {
    
function initializeR7Articles(){
  document.querySelectorAll('[data-r7-article]').forEach(root=>{
    if(root.dataset.r7Ready)return;
    root.dataset.r7Ready='true';
    const body=root.querySelector('[data-r7-body]');
    const headings=[...body.querySelectorAll('h2,h3,h4')].filter(heading=>heading.textContent.trim());
    const mobileBar=root.querySelector('[data-r7-mobile-product]');
    if(mobileBar&&'IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{mobileBar.hidden=!entries[0].isIntersecting;},{rootMargin:'-120px 0px -100px 0px'});
      observer.observe(body);
    }
    if(headings.length<2)return;
    headings.forEach((heading,index)=>{if(!heading.id)heading.id='r7-section-'+(index+1);});
    root.querySelectorAll('[data-r7-toc]').forEach(list=>{
      headings.forEach(heading=>{const item=document.createElement('li');const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent.trim();item.append(link);list.append(item);});
      list.parentElement.hidden=false;
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeR7Articles);}else{initializeR7Articles();}
document.addEventListener('shopify:section:load',initializeR7Articles);

  } catch(e) { console.error(e); }
})();
})();
